import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const PhoneInputComponent = ({ value, onChange, placeholder, isValid, label = "Phone Number"}) => {
  return (
    <div style={{ position: "relative" }}>
      <div
        style={{
          position: "absolute",
          zIndex: "100",
          marginLeft: "13px",
          fontSize: "11px",
          color: "#aaaa",
        }}
      >
        <span>{label}</span>
      </div>
      <PhoneInput
        country={"us"}
        // placeholder={placeholder}
        value={value}
        onChange={onChange}
        isValid={isValid}
      />
    </div>
  );
};

export default PhoneInputComponent;
